<div *ngIf="!dataUrl" class="camera-controls">
    <button class="button primary" type="button" (click)="photoInput.click()">
        Take photo
    </button>

    <input
        class="hidden-input"
        type="file"
        accept="image/*"
        capture="user"
        (change)="onPhotoSelected($event)"
        #photoInput
    />

    <span class="mobile-buttons-devider"></span>

    <button class="button secondary" type="button" (click)="photoGalery.click()">
        Upload photo
    </button>

    <input
        class="hidden-input"
        type="file"
        accept="image/*"
        (change)="onPhotoSelected($event)"
        #photoGalery
    >

    <ng-container *isUS>
        <ng-container *ngIf="canUseCurrentImage">
            <span class="mobile-buttons-devider"></span>
            <button class="button secondary" type="button" (click)="useCurrentPhoto()">
                Use Current
            </button>
        </ng-container>
    </ng-container>

</div>

<div *ngIf="dataUrl" class="image-preview">
    <div class="caption">Photo</div>

    <img id='selected-image-preview' [src]="dataUrl" alt="selected">

    <div class="image-preview-controls">
        <button class="button secondary" type="button" (click)="onRemoveSelectedPhoto()">
            Delete
        </button>
        <button
            *ngIf="!photoData?.uId && !currentPhotoLoaded"
            class="button primary"
            type="button"
            [disabled]="uploadInProgress"
            (click)="onConfirmSelectedPhoto()"
            >
            Confirm
        </button>
    </div>
</div>
